import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss'
})
export class CandidateFormComponent implements OnInit {
  @Input() candidate: any = {};
  document: any;
  constructor(public activeModal: NgbActiveModal, private fileService: FileService) {
  }

  ngOnInit(): void {
    if (this.candidate.document) {
      this.document = this.candidate.document;
    }
  }

  onSave(): void {
    this.candidate.document = this.document;
    this.activeModal.close(this.candidate);
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }

  onFileChange(event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      this.fileService.uploadFile(file, 'Candidate', 'Resume').subscribe(
        (uploadEvent: any) => {
          if (uploadEvent.body) {
            this.document = uploadEvent.body;
          }
        },
        error => {
          console.error('Upload error: ', error);
        }
      );
    }
  }
}
